import { combineReducers } from 'redux';

import { Reducer } from '../../../types';
import { StateListArticles, ArticleAction } from '../types';
import {
  updateStateByDocument,
  updateStateByVideo,
  updateArticleDocumentDownloadUrl,
  updateArticleVideoDownloadUrl,
  updateArticleVideoRef,
} from '../utils';
import {
  addItemToState,
  removeItemByState,
  updateItemByState,
} from '../../../util';
import { stripItems } from '../../../../utility/store';
import {
  getArticleListRequest,
  getArticleListSuccess,
  getArticleListFail,
  setArticleListDirty,
  createArticleSuccess,
  saveArticleSuccess,
  deleteArticleSuccess,
  saveArticleDocumentSuccess,
  clearArticleList,
  clearArticleState,
  getArticleDocumentDownloadUrlSuccess,
  getArticleSuccess,
  getArticleVideoDownloadUrlSuccess,
  getArticleVideoSuccess,
  saveArticleVideoSuccess,
  setRefreshArticleList,
  getArticleListRefreshSuccess,
  saveVideoThumbnailSuccess,
  updateProcessingMediaArticleSuccess,
  updateRefVideoRef, updateRefDocumentRef,
} from '../actions';

type ReducerOf<T extends keyof StateListArticles> = Reducer<StateListArticles, ArticleAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getArticleListRequest.type:
    case clearArticleList.type:
      return state ? stripItems(state) : null;

    case getArticleListSuccess.type:
    case getArticleListRefreshSuccess.type:
      return action.payload;

    case createArticleSuccess.type:
      return addItemToState(state, action.payload);

    case saveArticleSuccess.type:
    case getArticleSuccess.type:
      return updateItemByState(state, action.payload);

    case saveArticleDocumentSuccess.type:
    case updateRefDocumentRef.type:
      return updateStateByDocument(state, action.payload);

    case deleteArticleSuccess.type:
      return removeItemByState(state, action.payload);

    case getArticleDocumentDownloadUrlSuccess.type:
      return updateArticleDocumentDownloadUrl(state, action.payload);

    case getArticleVideoDownloadUrlSuccess.type:
      return updateArticleVideoDownloadUrl(state, action.payload);

    case getArticleVideoSuccess.type:
    case saveArticleVideoSuccess.type:
    case saveVideoThumbnailSuccess.type:
      return updateStateByVideo(state, action.payload);

    case updateRefVideoRef.type:
      return updateArticleVideoRef(state, action.payload);

    case clearArticleState.type:
      return null;

    case updateProcessingMediaArticleSuccess.type:
      return updateItemByState(state, action.payload);

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getArticleListRequest.type:
      return true;

    case getArticleListSuccess.type:
    case getArticleListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setArticleListDirty.type:
      return action.payload;

    case getArticleListSuccess.type:
    case getArticleListFail.type:
      return false;

    default:
      return state;
  }
};

const refresh: ReducerOf<'refresh'> = (state = false, action) => {
  switch (action.type) {
    case setRefreshArticleList.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<StateListArticles>({
  data,
  loading,
  dirty,
  refresh,
});
